module.exports = __webpack_public_path__ + "static/jp-kunnallissanomat.4383f349.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jp-kunnallissanomat.jpg
// module id = 828
// module chunks = 129563053867776